import React, { useState } from 'react';

function InputPopup({ isOpen, message, onOk, onCancel, inValue, inChange, ok, cancel }) {

    const [selectedReason, setSelectedReason] = useState('');
    const [isOther, setIsOther] = useState(true);
    const handleSelectChange = (e) => {
        const get = e.target.value;
        setSelectedReason(get);
        if (get === "Other") {
            setIsOther(false);
            inChange('');
        } else {
            inChange(get);
        }
    };

    if (!isOpen) return null;
    return (
        <>
            <div className="modal-overlay">
                <div className="modal-content" style={{ width: "35%" }}>
                    <h3>{message}</h3>
                    <select style={{ width: "94.2%", marginBottom: 0, marginTop: "10px" }} value={selectedReason} onChange={handleSelectChange}>
                        <option value="" disabled>Select Reason</option>
                        <option value="No Inventory">No Inventory</option>
                        <option value="Buyer Cancelled">Buyer Cancelled</option>
                        <option value="General Adjustment">General Adjustment</option>
                        <option value="Shipping Address Undeliverable">Shipping Address Undeliverable</option>
                        <option value="Other">Other</option>
                    </select>
                    <textarea type="text" disabled={isOther} style={{ marginTop: "10px", paddingTop: "19px", width: "94.3%" }} className='inputPopup' rows="15" cols="50" value={inValue} onChange={(e) => inChange(e.target.value)} />
                    <div className="modal-actions">
                        <button className="confirm-btn" onClick={onOk}>{ok}</button>
                        <button className="cancel-btn" onClick={onCancel}>{cancel}</button>
                    </div>
                </div>
            </div>
        </>
    )
}
export { InputPopup }